/**
 * QM8D — ProtectedRoute: Permission-basierter Route-Schutz
 * Extrahiert aus App.js (Phase 2 Refactoring)
 */
import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';

export default function ProtectedRoute({ permission, children }) {
  const { user } = useContext(AuthContext);
  if (permission && !user?.permissions?.[permission]) {
    return <Navigate to="/home" />;
  }
  return children;
}
